import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import { Container, Card, Button, Form } from "react-bootstrap";
import html2canvas from "html2canvas";


const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  // jpeg to pdf converter tool
const [images, setImages] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const imageUrls = files.map((file) => URL.createObjectURL(file));
    setImages(imageUrls);
  };

  const convertToPDF = async () => {
  const doc = new jsPDF();

  for (let i = 0; i < images.length; i++) {
    const img = new Image();
    img.src = images[i];

    // Wait for the image to load
    await new Promise((resolve) => {
      img.onload = resolve;
    });

    // Create a temporary canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Set canvas size to match the image
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    // Convert to data URL
    const imgData = canvas.toDataURL("image/png");

    // Add to PDF
    if (i > 0) doc.addPage();
    doc.addImage(imgData, "PNG", 10, 10, 190, 0);
  }

  doc.save("converted.pdf");
};

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                PNG to PDF Converter
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

              
        <p className="text-dark text-center">
          Our PNG to PDF Converter is a free and easy-to-use online tool that lets you quickly convert PNG images into high-quality PDF files. Whether you need to merge multiple PNGs into a single PDF or convert individual images, our tool ensures a seamless experience. No software installation is required—just upload your PNG file, click convert, and download your PDF instantly. It maintains image quality, supports batch conversion, and works on all devices. Secure, fast, and reliable, our converter is perfect for students, professionals, and anyone needing a hassle-free PNG to PDF conversion. Try it now for free! 🚀
        </p>
        <Form.Group controlId="pngFileInput" className="mb-3 text-center">
          <Form.Control type="file" multiple accept="image/png" onChange={handleFileChange} />
        </Form.Group>
        <div id="preview" className="p-3 text-center">
          {images.map((src, index) => (
            <img key={index} src={src} alt={`preview-${index}`} className="img-fluid mb-2" />
          ))}
        </div>
        <Button onClick={convertToPDF} className="btn btn-primary mt-3 w-100">
          Convert to PDF
        </Button>
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
